<div class="row-flex space-between">
  <h2 class="govuk-heading-m">Target period throughput details</h2>

  @if (isEditable()) {
    <a class="govuk-link" [routerLink]="[detailsLink()]">Change</a>
  }
</div>

<div class="x-scroll">
  <div class="overflow-auto overflow-auto-table">
    <govuk-table [columns]="tableColumns()" [data]="paginatedTableRows()">
      <ng-template let-column="column" let-row="row">
        @switch (column.field) {
          @case ('productName') {
            <strong>{{ row.productName }}</strong>
          }

          @case ('energy') {
            {{ displayRounded(row.energy) | number: '1.0-7' }} {{ measurementUnit() | measurementTypeToUnit }}/{{
              row.throughputUnit
            }}
          }

          @case ('improvementTarget') {
            {{ row.improvementTarget.toNumber() | percent: '1.0-3' }}
          }

          @case ('throughput') {
            {{ row.throughput | number: '1.0-7' }}
          }

          @case ('adjustedThroughput') {
            {{ row.adjustedThroughput.toNumber() | number: '1.0-3' }}
          }

          @case ('targetEnergy') {
            {{ row.targetEnergy.toNumber() | number: '1.0-3' }}
          }

          @default {
            {{ row[column.field] }}
          }
        }
      </ng-template>
    </govuk-table>
  </div>
</div>

@if (shouldShowPagination()) {
  <cca-pagination
    [count]="tableRows().length"
    [currentPage]="currentPage()"
    [pageSize]="pageSize()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  />
}

<h2 class="govuk-heading-m govuk-!-margin-top-6">
  Calculated {{ isCarbonMeasurement() ? 'carbon dioxide' : 'energy' }} amounts
</h2>

<dl govuk-summary-list>
  <div govukSummaryListRow>
    <dt govukSummaryListRowKey>
      Total target variable {{ isCarbonMeasurement() ? 'carbon dioxide' : 'energy' }} ({{
        measurementUnit() | measurementTypeToUnit
      }})
    </dt>
    <dd govukSummaryListRowValue>{{ displayRounded(totalTargetVariableEnergy()) | number: '1.0-7' }}</dd>
  </div>
</dl>
